export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('The field Code must be a string with a minimum length of 1 and a maximum length of 5') !== -1) {
        messages.push({
          message: 'addEditTypeFormatPresse.error.codoLengthError',
        });
      }
    }
  });
}
